import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { State } from '@nykaa/intl-shared/types';
import { pushData, pushEvent } from '@nykaa/data-layer/utils';
import { styled as Styled } from '@nykaa/ui-components';
import { toggleLanguageModal } from '@nykaa/intl-shared/store/action';
import TranslateIcon from 'shared/components/Icons/Translate';
import Tooltip from 'shared/components/Tooltip';
import TooltipContent from 'shared/components/Header/RightNav/Translate/TooltipContent';
import { getCookie } from 'helpers/utils/cookie';
import { LANG_CONFIG } from '@nykaa/intl-shared/constants';
import { LANGUAGE_HEADER_CLICKED } from '@nykaa/intl-shared/constants/trackingEvents';
import { VRN_NUDGE_SHOWN } from 'shared/constants';
import { useIsConfigHeader, useIsThemeHeader } from 'hooks/header';

const TranslateWrapper = Styled.button`
  background: transparent;
  border: none;
  padding: 12px;

  &:active {
    outline: none;
  }
`;

function Index() {
  const [isHidden, setIsHidden] = useState(true);
  const { showModal, isExperimentEnabled } = useSelector(
    (state: State) => state[LANG_CONFIG]
  );
  const isThemeHeader = useIsThemeHeader();
  const { headerTextColor } = useIsConfigHeader();
  // Redux Dispatch
  const dispatch = useDispatch();
  const handleClick = () => {
    toggleLanguageModal()(dispatch);
    pushEvent(LANGUAGE_HEADER_CLICKED, { langSelectorIconClick: 1 });
  };

  const handleTooltipClick = () => {
    setIsHidden(true);
    pushEvent(VRN_NUDGE_SHOWN, {
      vrnNudgeShown: 1,
    });
  };

  const hideTooltipOnScroll = useCallback(() => {
    window.setTimeout(() => {
      setIsHidden(true);
      window.removeEventListener('touchstart', hideTooltipOnScroll);
    }, 500);
  }, []);

  useEffect(() => {
    if (isExperimentEnabled) {
      const trackingData = {
        isSelectorShown: 1,
      };
      pushData(trackingData);
    }
  }, [isExperimentEnabled, isHidden]);

  useEffect(() => {
    const tooltipCookie = 'HST';
    const hasSeenTooltip = Number(getCookie(tooltipCookie));
    const hideModal = Boolean(hasSeenTooltip || showModal);
    setIsHidden(hideModal);
  }, [isExperimentEnabled, showModal]);

  useEffect(() => {
    if (isExperimentEnabled) {
      window.addEventListener('touchstart', hideTooltipOnScroll);
    }
    return () => window.removeEventListener('touchstart', hideTooltipOnScroll);
  }, [isExperimentEnabled, hideTooltipOnScroll]);

  if (!isExperimentEnabled) return <></>;

  return (
    isExperimentEnabled && (
      <Tooltip
        isHidden={true}
        content={() => <TooltipContent onClick={handleTooltipClick} />}
      >
        <TranslateWrapper onClick={handleClick}>
          <TranslateIcon
            isLight={isThemeHeader}
            color={headerTextColor}
          />
        </TranslateWrapper>
      </Tooltip>
    )
  );
}

export default Index;
